<template> 

    <div class="bg-white rounded-lg h-screen">

        <div class="sticky top-0 bg-white z-50">

            <div class="myCenter">

                <button 
                    class="classPageFontAwesomeButton"
                    @click="closePage">
                            
                    <font-awesome-icon icon="times-circle" size="2x"/> 
                </button>
            </div>
        </div>

        <div v-if="transferRequestsDetails.length > 0">

            <div v-for="(oneRequest, index) in transferRequestsDetails" :key="index">

                <div class="classPageRow">
                    
                    <label class="mr-5"><strong>{{ index + 1 }}: </strong></label>

                    <label
                    class="classPageDetailsLabel">
                    {{oneRequest.points}} {{$t('profile.points')}}</label>
                </div>
            </div>
        </div>

        <div v-else class="h-40">
                        
            <div class="myFullCenter mt-40">
                
                <p class="mt-2 lg:mt-5 p-5 bg-blue-300 rounded-full border-blue-800 border-4">
                    <strong>{{$t('business.noRequestsAvailable')}}</strong></p>
            </div>
        </div>
    </div>

</template>

<script> 
    export default {

        mounted(){

            // console.log(`transferRequestsDetails: ${JSON.stringify(this.transferRequestsDetails)}`);
        },

        props:{

            transferRequestsDetails:{

                type: Array
            },

            closePage:{

                type: Function
            }
        }
     }
</script>

<style>

</style>